import { SET_USER_VALUE } from "../constant";

const initialState = {
  currentUser: null,
  referenceToOldestKey: "",
  showSignInModal: false,
  showSignOutModal: false,
  showAddNewVideoModal: false,
  isAMA: false,
  AmaQuestion: false,
  AmaAnswer: false,
  showNoNewVideoAccessModal: false,
  showEditVideoModal: false,
  showAddNewProductModal: false,
  videoId: "",
  comment: "",
  commentParentId: "",
  showAddNewBugModal: false,
  showAddNewFeatureModal: false,
  showAddNewFeedbackModal: false,
  showUpdatePostStatusModal: false,
  showUpdateFeedbackModal: false,
  showDeleteFeedbackModal: false,
  showAddToRoadmapModal: false,
};

export default function formReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_VALUE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
